import script from "./BusinessDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./BusinessDetail.vue?vue&type=script&setup=true&lang=js"

import "./BusinessDetail.vue?vue&type=style&index=0&id=38e5281d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38e5281d"]])

export default __exports__